import React from 'react';
import { motion } from 'framer-motion';
export function PainPointsSection() {
  const points = ['Probás dietas y las abandonás', 'No sabés qué comer y terminás comiendo mal', 'Tenés ansiedad y picoteás todo el día', 'Sentís que todo te engorda', 'Estás hinchada/o constantemente', 'Querés bajar de peso pero sin sufrir'];
  return <section className="pt-10 pb-16 px-4 bg-brand-bg relative overflow-hidden" data-id="element-98">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-poppins font-black text-brand-text leading-tight" data-id="element-101">
            ⚠️ SI TE PASA ESTO, <br data-id="element-102" />
            <span className="text-brand-accent" data-id="element-103">ESTE PACK ES PARA VOS</span>
          </h2>
        </motion.div>

        <div className="w-full space-y-3 mb-10" data-id="element-104">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-center gap-4 bg-white p-5 md:p-6 rounded-2xl border border-green-200 shadow-sm hover:border-green-300 transition-colors w-full" data-id="element-105">
              <span className="text-2xl flex-shrink-0" data-id="element-106">❌</span>
              <p className="text-lg md:text-xl font-medium text-gray-700" data-id="element-107">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center w-full" data-id="element-108">
          <h3 className="text-2xl md:text-4xl font-poppins font-black text-red-600 animate-pulse" data-id="element-109">
            ¿CUÁNTO TIEMPO MÁS VAS A SEGUIR IGUAL?
          </h3>
        </motion.div>
      </div>
    </section>;
}